import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_report_template',
};

type UpdatedReportTemplate = {
  id: number;
  name: string;
  file?: any;
};

export const updateReportTemplateRequest = (data: UpdatedReportTemplate) => {
  const body = new FormData();
  const props = new Blob([JSON.stringify({ id: data.id, name: data.name })], {
    type: 'application/json',
  });

  body.append('reportTemplate', props);

  if (data.file) {
    body.append('reportTemplateFile', data.file);
  }

  return createRequest({
    url: config.url,
    method: config.method,
    body,
    headers: {
      // set required headers (multipart/form-data with boundary) automatically by broweser
    },
  });
};
